module.exports = __webpack_public_path__ + "df56cf969d01600913b21ba6a18b9e78.svg";